import React from 'react';
import clsx from 'clsx';
import Header from '../../components/Header/Header';
import Sidebar from '../../components/Sidebar/Sidebar';
import { Bar, Pie } from 'react-chartjs-2';
import { makeStyles } from '@material-ui/styles';
import SaveIcon from '@material-ui/icons/Save';
import ReactToPdf from 'react-to-pdf';
import {
    IconButton,
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Select,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    MenuItem,
    Grid,
    Divider,
    Switch,
    TextField,
    Typography,
    colors,
    InputLabel
} from '@material-ui/core';
import { get_property_report, get_showrooms } from '../../api/API';
import moment from 'moment/moment.js'
import Autocomplete from '@material-ui/lab/Autocomplete';
import DatePicker from 'react-date-picker';
import { CSVLink } from "react-csv";

const useStyles = makeStyles(theme => ({
    root: {
        padding: '24px',
    },

}));

export default class ReportProperty extends React.Component {


    constructor(props) {
        super(props);
        this.colors = ["rgba(41, 50, 66,0.6)",
            "rgba(110,115,118, 0.6)",
            "rgba(157,162,174, 0.6)",
            "rgba(102, 58, 68, 0.6)",
            "rgba(193,171,173, 0.6)",
            "rgba(145,104,72, 0.6)",
            "rgba(179,161,136, 0.6)",
            "rgba(95,120,128, 0.6)",
            "rgba(195,158,158, 0.6)"
        ];

        this.ref = React.createRef();
        this.pieref = React.createRef();
        this.state = {
            csv_output: [],
            csv_output_national: [],
            start_print: false,
            start_print_pie: false,

            redraw: false,
            chartData: {},
            doughnuts: [],
            showrooms: [],
            bar_options: {
                maintainAspectRatio: false,
                scales: {
                    yAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: 'Value'
                        },
                        ticks: {
                            min: 0,
                            max: 10,
                            stepSize: 1
                        }
                    }]
                }
            },
            values: {
                property: "",
                appointment_type: "all",
                date_from: moment().subtract(7, 'days').format('YYYY-MM-DD'),
                date_to: moment().format('YYYY-MM-DD'),
            },
            rawReport: [],
        };
        // this.get_data();
        this.get_showroom_data();
    }
    handleChange(e) {
        this.setState({
            ...this.state,
            values: {
                ...this.state.values,
                [e.target.name]: e.target.value
            }
        }, () => {
            this.get_data();
        });

    }

    async get_showroom_data() {
        var currentObj = this;
        let showrooms = await get_showrooms();
        if (showrooms) {
            currentObj.setState({
                ...this.state,
                showrooms: showrooms
            }, () => {
                // this.get_data();
            });
        }
    }

    parse_chart_data(data) {
        var new_bar_options = {

        };
        var max_y_ticks = 4;

        var labels = [];
        var doughnuts = [];
        var datasets = [{
            label: 'Appointment: No Show',
            stack: "stack1",
            backgroundColor: '#bdbdbd',
            borderColor: '#bdbdbd',
            borderWidth: 1,
            hoverBackgroundColor: '#bdbdbd',
            hoverBorderColor: '#bdbdbd',
            data: []
        }, {
            label: 'Appointment:  Arrived',
            stack: "stack1",
            backgroundColor: '#66bb6a',
            borderColor: '#66bb6a',
            borderWidth: 1,
            hoverBackgroundColor: '#66bb6a',
            hoverBorderColor: '#66bb6a',
            data: []
        }, {
            label: 'Appointment: Booked',
            stack: "stack1",
            backgroundColor: '#42a5f5',
            borderColor: '#42a5f5',
            borderWidth: 1,
            hoverBackgroundColor: '#42a5f5',
            hoverBorderColor: '#42a5f5',
            data: []
        },
        {
            label: 'Guests: No Show',
            stack: "stack2",
            backgroundColor: 'rgba(189, 189, 189, 0.56)',
            borderColor: 'rgba(189, 189, 189, 0.56)',
            borderWidth: 1,
            hoverBackgroundColor: 'rgba(189, 189, 189, 0.56)',
            hoverBorderColor: 'rgba(189, 189, 189, 0.56)',
            data: []
        },
        {
            label: 'Guests: Arrived',
            stack: "stack2",
            backgroundColor: 'rgba(102, 187, 106, 0.56)',
            borderColor: 'rgba(102, 187, 106, 0.56)',
            borderWidth: 1,
            hoverBackgroundColor: 'rgba(102, 187, 106, 0.56)',
            hoverBorderColor: 'rgba(102, 187, 106, 0.56)',
            data: []
        },
        {
            label: 'Guests: Booked',
            stack: "stack2",
            backgroundColor: 'rgba(66, 165, 245, 0.56)',
            borderColor: 'rgba(66, 165, 245, 0.56)',
            borderWidth: 1,
            hoverBackgroundColor: 'rgba(66, 165, 245, 0.56)',
            hoverBorderColor: 'rgba(66, 165, 245, 0.56)',
            data: []
        }
        ];



        for (var i = 0; i < data.length; i++) {
            labels.push(data[i].property);

            datasets[0].data.push(data[i].no_show);
            datasets[1].data.push(data[i].arrived);
            datasets[2].data.push(data[i].total - data[i].no_show - data[i].arrived);
            datasets[3].data.push(data[i].no_show_pax);
            datasets[4].data.push(data[i].arrived_pax);
            datasets[5].data.push(data[i].total_pax - data[i].no_show_pax - data[i].arrived_pax);

            max_y_ticks = max_y_ticks > parseInt(data[i].total_pax) ? max_y_ticks : parseInt(data[i].total_pax);
            var d_labels = [];
            var d_colors = [];
            var d_data = [];
            for (var j = 0; j < data[i].nationality.length; j++) {
                d_labels.push(data[i].nationality[j].country);
                d_data.push(data[i].nationality[j].amount);
                d_colors.push(this.get_country_color(data[i].nationality[j].country));
            }
            doughnuts.push({
                title: data[i].property,
                labels: d_labels,
                datasets: [{
                    label: data[i].property,
                    backgroundColor: d_colors,
                    borderColor: d_colors,
                    data: d_data
                }
                ]
            });

        }

        this.setState({
            ...this.state,
            chartData: {
                labels: labels,
                datasets: datasets
            },
            doughnuts: doughnuts,
            rawReport: data,
            bar_options: {
                ...new_bar_options,
                scales: {
                    yAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: 'Value'
                        },
                        ticks: {
                            min: 0,
                            max: max_y_ticks + 3,
                            stepSize: 1
                        }
                    }]
                }
            }
        }, () => {
            this.downloadCSV();
        });
    }

    get_country_color(country) {
        switch (country) {
            case "Singapore":
                return "#4880bc";
            case "China":
                return "#c0504c";
            case "Hong Kong":
                return "#99ba51";
            case "India":
                return "#800080";
            case "Indonesia":
                return "#408080";
            case "Malaysia":
                return "#E4FF1A";
            case "Taiwan":
                return "#44546A";
            case "USA":
                return "#ED7D31";
            default:
                return "#954F72";
        }
    }
    handleChangeDate(date, field) {
        this.setState({
            ...this.state,
            values: {
                ...this.state.values,
                [field]: date
            }
        });
    }
    async get_data() {
        var property = this.state.values.property;
        let property_arr = '';
        for (var i = 0; i < property.length; i++) {
            if (i == 0) {
                property_arr += property[i].property_id;
            } else {
                property_arr += ',' + property[i].property_id;
            }

        }

        var data = await get_property_report({
            ...this.state.values,
            date_from: moment(this.state.values.date_from).format("yyyy-MM-DD"),
            date_to: moment(this.state.values.date_to).format("yyyy-MM-DD"),
            property: property_arr
        });
        if (data) {
            this.parse_chart_data(data.data);
        }
    }
    downloadCSV() {
        var export_data = [];
        var header = ['', 'Appt. Arrived', 'Appt. No Show', "Appt. Booked", "Appt. Total", "Guest Arrived", "Guest No Show", "Guest Booked", "Guest Total"];

        export_data.push(header);

        var export_national = [];
        var countries = ["Singapore", "China", "Hong Kong", "India", "Indonesia", "Malaysia", "Taiwan", "USA", "Others"];
        export_national.push(['', ...countries]);

        this.state.rawReport.map(row => {

            var national_search = 0;
            var national_row = [row.property];
            for (let i = 0; i < countries.length; i++) {
                for (let j = 0; j < row.nationality.length; j++) {
                    if (row.nationality[j].country == countries[i]) {
                        national_search = row.nationality[j].amount;
                    }
                }
                national_row.push(national_search);
            }
            export_national.push(national_row);

            export_data.push([
                row.property,
                row.arrived,
                row.no_show,
                row.total - row.arrived - row.no_show,
                row.total,
                row.arrived_pax,
                row.no_show_pax,
                row.total_pax - row.arrived_pax - row.no_show_pax,
                row.total_pax
            ]);
        });





        this.setState({
            ...this.state,
            csv_output: export_data,
            csv_output_national: export_national
        }, () => {
            console.log(this.state)
        }
        );
    }

    render() {
        return (
            <React.Fragment>
                <Header
                    classes={this.props.classes}
                    onSidebarOpen={this.props.handleSidebarOpen}
                />
                <Sidebar
                    classes={this.props.classes}
                    onClose={this.props.handleSidebarClose}
                    open={this.props.shouldOpenSidebar}
                    variant={this.props.isDesktop ? 'persistent' : 'temporary'}
                />
                <main className={this.props.classes.content}>
                    <div className={this.props.classes.toolbar} />
                    <br></br>

                    <div
                        {...this.props}
                        className={clsx(this.props.classes.root, this.props.className)}
                        style={{
                            height: "auto",
                            padding: 8
                        }}
                    >
                        <Card>
                            <CardHeader
                                action={
                                    <>
                                        <ReactToPdf
                                            targetRef={this.ref}
                                            filename={"Property_Report_" + this.state.values.date_from + "_" + this.state.values.date_to + ".pdf"}
                                            scale={0.8}
                                            x={2}
                                            y={0}
                                            onComplete={(() => {
                                                this.setState({
                                                    ...this.state,
                                                    start_print: false,
                                                    redraw: true
                                                })
                                            }).bind(this)}
                                        >
                                            {({ toPdf }) => (
                                                <IconButton
                                                    onClick={(() => {
                                                        window.scrollTo(0, 0);
                                                        this.setState({
                                                            ...this.state,
                                                            start_print: true,
                                                            redraw: true
                                                        }, () => {
                                                            setTimeout(() => {

                                                                toPdf();
                                                            }, 2000);
                                                        });

                                                    }).bind(this)}
                                                >
                                                    <SaveIcon style={{ color: "black" }} />
                                                </IconButton>
                                            )}
                                        </ReactToPdf>
                                        <IconButton

                                        >
                                            <CSVLink
                                                data={this.state.csv_output}
                                                filename={"Property_Report_" + this.state.values.date_from + "_" + this.state.values.date_to + ".csv"}
                                            >
                                                <img style={{
                                                    width: 26
                                                }} src={require("../../assets/excel_icon.png")}></img>
                                            </CSVLink>
                                        </IconButton>
                                    </>
                                }
                                title="Property Report"
                            />
                            <Divider />
                            <CardContent class="report_container" className={useStyles.content}>
                                <div
                                    className="report_filter multiselect_reports"
                                >
                                    <div className="filter_field_wrapper">
                                        <Autocomplete
                                            multiple
                                            // className="multi_add_field"
                                            id="tags-standard"
                                            name="unit"
                                            options={this.state.showrooms}
                                            getOptionLabel={(option) => option.name}
                                            onChange={(event, newVal) => {
                                                this.setState({
                                                    ...this.state,
                                                    values: {
                                                        ...this.state.values,
                                                        property: newVal
                                                    }
                                                }, () => {
                                                    this.get_data();
                                                });
                                            }}
                                            renderInput={(params) => (

                                                <TextField
                                                    {...params}
                                                    style={{
                                                        width: "100%"
                                                    }}
                                                    label="Property"
                                                    placeholder='select property'
                                                />
                                            )}
                                        />
                                    </div>
                                    <div className="filter_field_wrapper">

                                        <InputLabel shrink id="metric_label">
                                            Guest Type
                                        </InputLabel>

                                        <Select
                                            className="full_width"
                                            labelId="appointment_type"
                                            label="appointment_type"
                                            onChange={this.handleChange.bind(this)}
                                            name="appointment_type"
                                            value={this.state.values.appointment_type}
                                        >
                                            <MenuItem
                                                value="all">
                                                All
                                            </MenuItem>
                                            <MenuItem
                                                value="1">
                                                New Prospect
                                            </MenuItem>
                                            <MenuItem
                                                value="2">
                                                Prospect Revisit
                                            </MenuItem>
                                            <MenuItem
                                                value="3">
                                                Buyer Revisits
                                            </MenuItem>
                                        </Select>
                                    </div> 
                                    <div className="filter_field_wrapper">
                                        <TextField
                                            type="date"
                                            name="date_from"
                                            label="From"
                                            onChange={this.handleChange.bind(this)}
                                            value={this.state.values.date_from}
                                            className="full_width"
                                        />
                                    </div>
                                    {/* <DatePicker
                                        style={{
                                            marginTop: "1%"
                                        }}
                                        format="dd/MM/y"
                                        value={this.state.values.date_from}
                                        onChange={(date => this.handleChangeDate(date, 'date_from')).bind(this)}
                                        className="datepicker"
                                    ></DatePicker>
                                    <DatePicker
                                        style={{
                                            marginTop: "1%"
                                        }}
                                        format="dd/MM/y"
                                        value={this.state.values.date_to}
                                        onChange={(date => this.handleChangeDate(date, 'date_to')).bind(this)}
                                        className="datepicker"
                                    ></DatePicker> */}
                                    <div className="filter_field_wrapper">
                                        <TextField
                                            type="date"
                                            name="date_to"
                                            label="to"
                                            className="full_width"
                                            onChange={this.handleChange.bind(this)}
                                            value={this.state.values.date_to}

                                        />
                                    </div>
                                </div>
                                {!this.state.start_print_pie && (

                                    <div
                                        style={{
                                            width: this.state.start_print ? 900 : "auto"
                                        }}
                                        ref={this.ref}>
                                        {this.state.start_print && (
                                            <div style={{
                                                marginBottom: 30
                                            }}>
                                                <Grid container>
                                                    <Grid item md={3}>
                                                        <img src={require("../../assets/logo_small.png")}></img>
                                                        <p>Showing date: {this.state.values.date_from} to {this.state.values.date_to}</p></Grid>
                                                    <Grid item md={6} style={{
                                                        textAlign: 'center'
                                                    }}>
                                                        <h1>Property Overview</h1>
                                                    </Grid>
                                                </Grid>


                                            </div>
                                        )}
                                        <div style={{
                                            height: '20vh',
                                            maxHeight: '60vh'
                                        }}>
                                            <Bar
                                                redraw={this.state.redraw}
                                                options={{
                                                    ...this.state.bar_options,
                                                    maintainAspectRatio: false,
                                                    devicePixelRatio: 2
                                                }}
                                                data={this.state.chartData}></Bar>
                                        </div>
                                        <br></br>
                                        <br></br>
                                        <Table className="report_table hide_mobile">
                                            <TableHead>
                                                <TableRow >
                                                    <TableCell style={{
                                                        textAlign: "center",
                                                        backgroundColor: "black",
                                                        color: "white"
                                                    }}></TableCell>
                                                    <TableCell style={{
                                                        textAlign: "center",
                                                        backgroundColor: "black",
                                                        color: "white"
                                                    }}
                                                        colSpan={4}>Appointments</TableCell>
                                                    <TableCell
                                                        style={{
                                                            textAlign: "center",
                                                            backgroundColor: "black",
                                                            color: "white"
                                                        }}
                                                        colSpan={4}>Guests</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell></TableCell>
                                                    <TableCell
                                                    >Arrived</TableCell>
                                                    <TableCell>No Show</TableCell>
                                                    <TableCell>Booked</TableCell>
                                                    <TableCell
                                                        className="bold"
                                                    >Total</TableCell>
                                                    <TableCell
                                                        className="section_2"
                                                    >Arrived</TableCell>
                                                    <TableCell
                                                        className="section_2"
                                                    >No Show</TableCell>
                                                    <TableCell
                                                        className="section_2"
                                                    >Booked</TableCell>
                                                    <TableCell
                                                        className="bold section_2"
                                                    >Total</TableCell>
                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {this.state.rawReport.map((row) => (
                                                    <TableRow>
                                                        <TableCell className="bold">{row.property}</TableCell>
                                                        <TableCell>{row.arrived}</TableCell>
                                                        <TableCell>{row.no_show}</TableCell>
                                                        <TableCell>{row.total - row.arrived - row.no_show}</TableCell>
                                                        <TableCell className="bold">{row.total}</TableCell>
                                                        <TableCell className="section_2">{row.arrived_pax}</TableCell>
                                                        <TableCell className="section_2">{row.no_show_pax}</TableCell>
                                                        <TableCell className="section_2">{row.total_pax - row.arrived_pax - row.no_show_pax}</TableCell>
                                                        <TableCell className="section_2 bold">{row.total_pax}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>


                                        <Table className="report_table hide_desktop">
                                            <TableHead>
                                                <TableRow >
                                                    <TableCell style={{
                                                        textAlign: "center",
                                                        backgroundColor: "black",
                                                        color: "white"
                                                    }}></TableCell>

                                                    <TableCell
                                                        style={{
                                                            textAlign: "center",
                                                            backgroundColor: "black",
                                                            color: "white"
                                                        }}
                                                        colSpan={4}>Appointments</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell></TableCell>
                                                    <TableCell
                                                    >Arrived</TableCell>
                                                    <TableCell>No Show</TableCell>
                                                    <TableCell>Booked</TableCell>
                                                    <TableCell
                                                        className="bold"
                                                    >Total</TableCell>

                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {this.state.rawReport.map((row) => (
                                                    <TableRow>
                                                        <TableCell className="bold">{row.property}</TableCell>
                                                        <TableCell>{row.arrived}</TableCell>
                                                        <TableCell>{row.no_show}</TableCell>
                                                        <TableCell>{row.total - row.arrived - row.no_show}</TableCell>
                                                        <TableCell className="bold">{row.total}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>

                                        <Table className="report_table hide_desktop">
                                            <TableHead>
                                                <TableRow >
                                                    <TableCell style={{
                                                        textAlign: "center",
                                                        backgroundColor: "black",
                                                        color: "white"
                                                    }}></TableCell>

                                                    <TableCell
                                                        style={{
                                                            textAlign: "center",
                                                            backgroundColor: "black",
                                                            color: "white"
                                                        }}
                                                        colSpan={4}>Guests</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell></TableCell>

                                                    <TableCell
                                                        className="section_2"
                                                    >Arrived</TableCell>
                                                    <TableCell
                                                        className="section_2"
                                                    >No Show</TableCell>
                                                    <TableCell
                                                        className="section_2"
                                                    >Booked</TableCell>
                                                    <TableCell
                                                        className="bold section_2"
                                                    >Total</TableCell>
                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {this.state.rawReport.map((row) => (
                                                    <TableRow>
                                                        <TableCell className="bold">{row.property}</TableCell>

                                                        <TableCell className="section_2">{row.arrived_pax}</TableCell>
                                                        <TableCell className="section_2">{row.no_show_pax}</TableCell>
                                                        <TableCell className="section_2">{row.total_pax - row.arrived_pax - row.no_show_pax}</TableCell>
                                                        <TableCell className="section_2 bold">{row.total_pax}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                        <br></br>
                                        <br></br>

                                    </div>

                                )}
                                <div
                                    style={{
                                        display: 'flex',
                                        marginLeft: "2%",
                                        marginRight: "2%",
                                        marginBottom: "2%",
                                        borderBottom: "1px solid black",

                                    }}
                                >
                                    <h1>Nationality Breakdown</h1>
                                    <div
                                        style={{
                                            flexGrow: 1,
                                            textAlign: "right"
                                        }}
                                    >
                                        <ReactToPdf
                                            targetRef={this.pieref}
                                            filename={"Property_Nationality_" + this.state.values.date_from + "_" + this.state.values.date_to + ".pdf"}
                                            scale={0.8}
                                            x={2}
                                            y={0}
                                            onComplete={(() => {
                                                this.setState({
                                                    ...this.state,
                                                    start_print_pie: false,
                                                    redraw: true
                                                })
                                            }).bind(this)}
                                        >
                                            {({ toPdf }) => (
                                                <IconButton
                                                    onClick={(() => {
                                                        window.scrollTo(0, 0);
                                                        this.setState({
                                                            ...this.state,
                                                            start_print_pie: true,
                                                            redraw: true
                                                        }, () => {
                                                            setTimeout(() => {

                                                                toPdf();
                                                            }, 2000);
                                                        });

                                                    }).bind(this)}
                                                >
                                                    <SaveIcon style={{ color: "black" }} />
                                                </IconButton>
                                            )}
                                        </ReactToPdf>
                                        <IconButton

                                        >
                                            <CSVLink
                                                data={this.state.csv_output_national}
                                                filename={"Property_Report_By_Nationality_" + this.state.values.date_from + "_" + this.state.values.date_to + ".csv"}
                                            >
                                                <img style={{
                                                    width: 26
                                                }} src={require("../../assets/excel_icon.png")}></img>
                                            </CSVLink>
                                        </IconButton>
                                    </div>
                                </div>
                                <div
                                    ref={this.pieref}
                                    style={{
                                        width: this.state.start_print_pie ? 900 : 'auto'
                                    }}
                                >
                                    {(this.state.start_print_pie) && (
                                        <Grid container>
                                            <Grid item md={3}>
                                                <img src={require("../../assets/logo_small.png")}></img>
                                                <p
                                                    style={{
                                                        marginBottom: 30
                                                    }}
                                                >Showing date: {this.state.values.date_from} to {this.state.values.date_to}</p></Grid>
                                            <Grid item md={6} style={{
                                                textAlign: 'center'
                                            }}>
                                                <h1 >Property Overview By Nationality</h1>
                                            </Grid>
                                        </Grid>
                                    )}

                                    <Grid container className="doughnut_padding" spacing={1}>
                                        {this.state.doughnuts.map(doughnut => (
                                            <Grid item md={this.state.start_print_pie ? 6 : 4}>
                                                <h3>{doughnut.title}</h3>
                                                <hr></hr>
                                                <Pie redraw={this.state.redraw} data={doughnut}></Pie>
                                            </Grid>
                                        ))}

                                    </Grid>
                                </div>
                            </CardContent>
                        </Card>
                    </div>
                </main>
            </React.Fragment>
        )
    }
}
